import { FaEthereum } from "react-icons/fa";
import { PolygonIcon } from "../components/common/select/selectIcon";

export const networkObj = [
  {
    name: "Ethereum",
    value: 1,
    image: FaEthereum,
  },
  {
    name: "Polygon",
    value: 137,
    image: PolygonIcon,
  },
  {
    name: "Rinkeby",
    value: 4,
    image: FaEthereum,
  },
];
